import { render } from "./Singin.vue?vue&type=template&id=64ae011b&scoped=true"
import script from "./Singin.vue?vue&type=script&lang=js"
export * from "./Singin.vue?vue&type=script&lang=js"

import "./Singin.vue?vue&type=style&index=0&id=64ae011b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae011b"]])

export default __exports__